import Vue from "vue";

export class CaixaCTO {
    static create() {
        return {
            fibra: {
                _id: null,
                numero: null
            },
            splitter1: {
                _id: null,
                potencia: null
            },
            splitter2: {
                _id: null,
                potencia: null
            },
            sinal: null,
            obs: null,
            portas: 8,
            place: [0, 0],
            numero: null,
            nome: null
        };
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static byID(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("caixa-cto/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static byFibra(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("caixa-cto/by-fibra/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static byPortaPON(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("caixa-cto/by-porta-pon/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static excluir(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .delete("caixa-cto/" + id)
                .then(() => resolve(), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static all() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("caixas-cto")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param data
     * @return {Promise}
     */
    static save(data) {
        return new Promise((resolve, reject) => {
            let promisse = null;

            if (data._id) {
                promisse = Vue.http.put("caixa-cto/" + data._id, data);
            } else {
                promisse = Vue.http.post("caixa-cto/0", data);
            }

            promisse.then(() => resolve(), err => reject(err));
        });
    }
}
